import React, {useState} from 'react';
import {Button, Modal} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import styles from './RemoveCustomerModal.module.scss';
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import LockConfirmationModal from "./LockConfirmationModal";


function RemoveCustomerModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, handleDelete: Function, handleLock: Function, canDeleteEnv: boolean, canLockEnv: boolean }) {

    const [deleteConfirmationModalVisible, setDeleteConfirmationModalVisible] = useState(false);
    const [lockConfirmationModalVisible, setLockConfirmationModalVisible] = useState(false);
    
    const renderModalContent = () => {
        let modalContent;

        modalContent = (
            <div className={styles.RemoveCustomerButtonContainer}>
                <div className={styles.RemoveCustomerButtonElement}>
                    <Button
                        text={'Lock'}
                        onClick={() => setLockConfirmationModalVisible(true)}
                        disabled={!props.canLockEnv}
                    />
                </div>
                <div className={styles.RemoveCustomerButtonElement}>
                    <Button
                        text={'Delete'}
                        onClick={() => setDeleteConfirmationModalVisible(true)}
                        disabled={!props.canDeleteEnv}
                    />
                </div>
            </div>
        )

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='teal'
            heading={'Remove ' + props.selectedCustomer.name}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
            
            {deleteConfirmationModalVisible ?
                <DeleteConfirmationModal
                    visible={deleteConfirmationModalVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setDeleteConfirmationModalVisible(false)}
                    handleDelete={props.handleDelete}
                /> : undefined
            }

            {lockConfirmationModalVisible ?
                <LockConfirmationModal
                    visible={lockConfirmationModalVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setLockConfirmationModalVisible(false)}
                    handleLock={props.handleLock}
                /> : undefined
            }
        </>
    )
}

export default RemoveCustomerModal;
